import React from "react";

const Idea = () => {
  return <div>Idea</div>;
};

export default Idea;
